/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";

import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import CircularProgress from "@mui/joy/CircularProgress"; // Import CircularProgress
import SearchIcon from "@mui/icons-material/Search";

import { useNavigate } from "react-router-dom";
import { invoiceStatusOptionsEmployee } from "../utils/constants";
import { OrderTableProps, InvoiceEntry, CombinedSearchInvoiceEntry } from "../utils/types";
import { useGetAgreedAndForwardMultipleMutation, useGetEmployeeDetailsODataQuery, useGetGEMInvoicesQuery, useSearchGEMInvoicesQuery, useSoftDeleteInvoiceMutation, useGetFetchLocationQuery } from "../services/invoices/InvoiceApiSlice";
import MultiSelectCheckboxDropdown from "../components/MultiSelectCheckdownDropbox";
import { toast } from "react-toastify";
import { DateRange, Widgets } from "@mui/icons-material";
import { displayOptional } from "../utils/utils";
import { useGetEmpListQuery } from "../services/vendor/employeeDataSlice";
import { Autocomplete } from "@mui/joy";
import ClearIcon from '@mui/icons-material/Clear';

type Order = "asc" | "desc";

// --- Helper functions remain unchanged ---
const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "N/A";
  // try {
  //   const date = new Date(dateString);
  //   if (isNaN(date.getTime())) return dateString;
  //   return date.toLocaleDateString(undefined, {
  //     year: "numeric",
  //     month: "short",
  //     day: "numeric",
  //   });
  // } catch (e) {
  //   return dateString;
  // }
  const date = new Date(dateString);
  return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
};

export default function GEMInvoicesTable({ isPendingPage }: OrderTableProps) {
  const navigate = useNavigate();

  const [gemInvoiceList, setGemInvoiceList] = React.useState([]);
  const [selectGemInvoice, setSelectGemInvoice] = React.useState([]);
  const [selectedList, setSelectedList] = React.useState([]);
  // const [locationList, setLocationList] = React.useState([]);

  const { data: GEMInvoicesdata } = useGetEmployeeDetailsODataQuery(0);
  const [agreedandforwardSelectedList] = useGetAgreedAndForwardMultipleMutation();
  // const { data: fetchLoction } = useGetFetchLocationQuery(0);

  React.useEffect(() => {

    if (GEMInvoicesdata?.d?.results) {
      var temp: any = [];
      var list: any = [];
      GEMInvoicesdata?.d?.results.map((item: any) => {
        if (temp.indexOf(item.EMP_NAME) === -1) {
          temp.push(item.EMP_NAME);
          list.push({ label: item.EMP_NAME, ...item })
          return;
        }

      })
      setGemInvoiceList([...list]);
    }
  }, [GEMInvoicesdata])

  const tableHeaders: Array<{
    id: any;
    label: string;
    minWidth: number;
    numeric?: boolean;
    disableSort?: boolean;
  }> = [
      { id: "bts_no", label: "BTS No.", minWidth: 130 },
      { id: "vendor_name", label: "Vendor Name", minWidth: 130 },
      { id: "vendor_code", label: "Vendor Code", minWidth: 130 },
      { id: "GEMID", label: "GEMID", minWidth: 130 },
      { id: "Name", label: "Name", minWidth: 130 },
      { id: "Mobile", label: "Mobile", minWidth: 130 },
      { id: "COROWH", label: "CO/RO/WH", minWidth: 130 },
      { id: "bts_entry_date", label: "Entry Date", minWidth: 110 },
      { id: "po_no", label: "PO/Contract", minWidth: 130 },
      { id: "bill_no", label: "Bill No.", minWidth: 110 },
      { id: "req_type", label: "Request Type", minWidth: 130 },
      ...(!isPendingPage
        ? [
          {
            id: "invoicenumber" as keyof InvoiceEntry,
            label: "Inv/Ref No.",
            minWidth: 150,
          },
        ]
        : []),
      { id: "bill_date", label: "Invoice Date", minWidth: 110 },
      { id: "tax_amount", label: "Tax Amt.", minWidth: 70, numeric: true },
      { id: "bill_amount", label: "Invoice Amt.", minWidth: 130, numeric: true },
      { id: "assign-to", label: "Assign To", minWidth: 130 },
    ];

  // ===================================================================
  // === 1. ALL HOOKS ARE CALLED AT THE TOP, UNCONDITIONALLY         ===
  // ===================================================================
  const [openFilterModal, setOpenFilterModal] = React.useState(false);
  const [deleteModalId, setDeleteModalId] = React.useState<number | string>();

  const [currentPage, setCurrentPage] = React.useState(1);
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<keyof InvoiceEntry | keyof CombinedSearchInvoiceEntry>("bts_entry_date");
  const [filterInputs, setFilterInputs] = React.useState<any>({
    bts_no: "",
    po_contract: "",
    invoice_status: [] as string[],
    vendor_code: "",
    vendor_name: "",
    bill_date: "",
    location: "",
  });
  const [softDeleteInvoice, { isLoading: deleteInprogress, isSuccess: deleteSuccess, isError: errorDeleting, error, data: deleteResponse }] = useSoftDeleteInvoiceMutation();

  const clearFilter = () => {
    setFilterInputs({ bts_no: "", po_contract: "", invoice_status: [] as string[], vendor_code: "", vendor_name: "", bill_date: "", location: "" });
  };

  React.useEffect(() => {
    clearFilter();
  }, [isPendingPage]);
  const [debouncedFilters, setDebouncedFilters] = React.useState(filterInputs);
  React.useEffect(() => {
    const handler = setTimeout(() => {

      setDebouncedFilters(filterInputs);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filterInputs]);

  const {
    data,
    error: errorEmployeeInvoices,
    isLoading: loadingEmployeeInvoices,
    isFetching,
  } = useGetGEMInvoicesQuery({ page: currentPage, per_page: 10 }, { refetchOnMountOrArgChange: true });

  const { data: employeeList } = useGetEmpListQuery();

  const [debouncedFilterInputs, setDebouncedFilterInputs] = React.useState(filterInputs);

  const isSearchActive = React.useMemo(
    () =>
      !!(
        debouncedFilters.bts_no ||
        debouncedFilters.po_contract ||
        debouncedFilters.invoice_status.length > 0 ||
        debouncedFilters.vendor_name ||
        debouncedFilters.vendor_code ||
        debouncedFilters.bill_date ||
        debouncedFilters.location
      ),
    [debouncedFilters]
  );

  const searchApiArgs = {
    bts_no: debouncedFilters.bts_no,
    po_contract: debouncedFilters.po_contract,
    vendor_name: debouncedFilters.vendor_name,
    vendor_code: debouncedFilters.vendor_code,
    bill_date: debouncedFilters.bill_date,
    status: debouncedFilters.invoice_status.join(","),
    location: debouncedFilters.location
  };

  const {
    data: searchResults,
    isLoading: isLoadingSearch,
    isFetching: isFetchingSearch,
    refetch,
  } = useSearchGEMInvoicesQuery(searchApiArgs, {
    skip: !isSearchActive,
  });


  if (loadingEmployeeInvoices && !isSearchActive) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  //https://b0314a8ec2f9.ngrok-free.app/fetch/location

  if (errorEmployeeInvoices) {
    return (
      <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
        Error loading data.
      </Typography>
    );
  }

  // ===================================================================
  // === 3. SAFELY ACCESS DATA AND DEFINE HANDLERS                   ===
  // ===================================================================

  // Safely destructure data with fallback defaults to prevent crashes
  const displayedData = data;
  const entries = isSearchActive ? searchResults?.entries : displayedData?.entries || [];
  const pagination = isSearchActive ? null : displayedData.pagination;
  // const isLoading = isSearchActive ? isLoadingSearch : loadingEmployeeInvoices;
  const isLoading = loadingEmployeeInvoices;
  const isFetchingData = isSearchActive ? isFetchingSearch : isFetching;

  const handleSort = (property: keyof InvoiceEntry | keyof CombinedSearchInvoiceEntry) => {
    const header = tableHeaders.find((h) => h.id === property);
    if (header?.disableSort) return;
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setCurrentPage(1);
  };
  //  const handleView = (invoiceId: number | string) => { /* Your logic here */ };
  // const handleEdit = (invoiceId: number | string) => { /* Your logic here */ };
  const handleDelete = async (invoiceId: number | string) => {
    if (!invoiceId) {
      console.error("No invoice ID provided to delete.");
      return;
    }
    try {
      const response = await softDeleteInvoice({
        invoice_id: String(invoiceId),
      }).unwrap();
      // const response = await softDeleteInvoice({
      //   invoice_id: Number(extractInvoiceNumberWithRegex(invoiceId)),
      // }).unwrap();

      setDeleteModalId(null);
      //   refetchInvoices();
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
      setDeleteModalId(null);
      console.error("Failed to delete invoice:", err);
    }
  };
  // Example of how you would navigate to the edit page
  const handleEdit = (invoiceId, vendor_id) => {
    localStorage.setItem("vendor_id", vendor_id);
    navigate(`/approver-page/${btoa(btoa(invoiceId))}`, {
      state: { isReadOnly: false }, // You can still pass secondary data
    });
  };

  const handleView = (invoiceId) => {
    //const invoiceId = invoice.id;

    navigate(`/employee/view-invoice-entry/${invoiceId}`, {
      state: { isReadOnly: true }, // Tell the component to be read-only
    });
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    if (pagination) {
      setCurrentPage((prev) => Math.min(prev + 1, pagination?.pages));
    }
  };

  // Filter handlers remain the same
  const handleFilterChange = (setter: (value: any) => void, value: any) => {
    setter(value);
    setCurrentPage(1);

  };
  const handleBtsNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bts_no: val })), event.target.value);
  };
  const handlePoContractChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, po_contract: val })), event.target.value);
  };
  const handleInvoiceStatusChange = (selectedStatusValues: string[]) => {
    handleFilterChange((val) => setFilterInputs((prevArgs) => ({ ...prevArgs, invoice_status: val })), selectedStatusValues);
  };
  const handleVendorCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_code: val })), event.target.value);
  };
  const handleVendorNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_name: val })), event.target.value);
  };
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bill_date: val })), event.target.value);
  };
  // const handleLocationChange = (selectedValue: any) => {
  //   setFilterInputs({ ...filterInputs, location: selectedValue.value });
  //   setCurrentPage(1);
  // };



  const handleApplyFiltersFromModal = () => {
    setDebouncedFilterInputs(filterInputs); // Apply filters when button is clicked
    setOpenFilterModal(false);
  };

  const handlechooseGemInvoiceMember = (value: any, index, invoice: any) => {


    let temp = [...selectGemInvoice];
    temp[index] = value === null ? null : { bts_no: invoice.bts_no, perner: value.PERNR.trim(), perner_name: value?.EMP_NAME, user_id: localStorage.getItem("employee_id"), user_name: localStorage.getItem("employee_name") };
    setSelectGemInvoice([...temp]);

    let temp1 = temp.filter((item) => !!item);

    setSelectedList([...temp1]);

  }

  const onHendleSendSelectedList = async () => {
    try {
      const response: any = await agreedandforwardSelectedList([...selectedList]);
      if (response?.data?.message) {
        toast.success(response?.data?.message)
      } else {
        toast.error(response?.error?.data?.message)
      }
      setSelectedList([]);
      setSelectGemInvoice([]);
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }

  }


  const renderFilters = (isMobile: boolean) => (
    <>
      {/* Your filter JSX remains the same */}
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>BTS No.</FormLabel>
        <Input placeholder="Search BTS No." startDecorator={<SearchIcon />} value={filterInputs.bts_no} onChange={handleBtsNoChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Purchase Order/Contract</FormLabel>
        <Input placeholder="PO/Contract" startDecorator={<SearchIcon />} value={filterInputs.po_contract} onChange={handlePoContractChange} />
      </FormControl>
      {!isPendingPage && (
        <Box sx={isMobile ? { mt: 1 } : { width: "14%" }}>
          <MultiSelectCheckboxDropdown
            label="Invoice Status"
            options={invoiceStatusOptionsEmployee}
            selectedValues={filterInputs?.invoice_status || []}
            onChange={handleInvoiceStatusChange}
            placeholder="Filter by status"
            size="sm"
          />
        </Box>
      )}
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Vendor Name</FormLabel>
        <Input placeholder="Vendor Name" startDecorator={<SearchIcon />} value={filterInputs.vendor_name} onChange={handleVendorNameChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Vendor Code</FormLabel>
        <Input placeholder="Vendor Code" startDecorator={<SearchIcon />} value={filterInputs.vendor_code} onChange={handleVendorCodeChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Bill Date</FormLabel>
        <Input startDecorator={<DateRange />} onChange={handleDateChange} type="date" placeholder="dd/mm/yyyy" value={filterInputs.bill_date} />
      </FormControl>
      {(filterInputs?.bts_no !== "" ||
        filterInputs?.bill_date !== "" ||
        filterInputs?.invoice_status?.length !== 0 ||
        filterInputs?.po_contract !== "" ||
        filterInputs?.vendor_code !== "" ||
        filterInputs?.vendor_name !== "") && (
          <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
            <FormLabel>&nbsp;</FormLabel>
            <Button onClick={clearFilter} sx={{ maxWidth: "fit-content" }} size="sm" variant="soft" color="danger">
              <ClearIcon />
            </Button>
          </FormControl>
        )}

    </>
  );

  if (isLoading && !entries) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // ===================================================================
  // === 4. RENDER THE COMPONENT                                     ===
  // ===================================================================
  return (
    <React.Fragment>
      <>
        <Sheet
          className="SearchAndFilters-mobile"
          sx={{
            display: { xs: "flex", sm: "none" },
            justifyContent: "flex-end",
            p: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button variant="outlined" color="neutral" onClick={() => setOpenFilterModal(true)}>
            Filters
          </Button>
        </Sheet>
        <Modal open={openFilterModal} onClose={() => setOpenFilterModal(false)}>
          <ModalDialog aria-labelledby="filter-modal" layout="center" sx={{ p: 2, width: "calc(100% - 32px)", maxWidth: 400 }}>
            <ModalClose />
            <Typography id="filter-modal" level="h4">
              Filters
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Sheet sx={{ display: "flex", flexDirection: "column", gap: 1.5, flexWrap: 'nowrap' }}>
              {renderFilters(true)}
              <Button color="primary" onClick={handleApplyFiltersFromModal} sx={{ mt: 1 }}>
                Apply Filters
              </Button>
            </Sheet>
          </ModalDialog>
        </Modal>
        <Box
          className="SearchAndFilters-tabletUp"
          sx={{
            borderRadius: "sm",
            pt: 1,
            pb: 1,
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            width: "100%",
            flexWrap: "nowrap",
            gap: 1.5,
            "& > *": { minWidth: { xs: "120px", md: "160px" } },
          }}
        >
          {renderFilters(false)}
        </Box>

      </>

      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          width: "100%",
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 300,
        }}
      >
        <Table
          className="gem-invoice-table"
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground": "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground": "var(--joy-palette-background-level1)",
          }}

        >
          <thead>
            {/* Table Headers remain the same */}
            <tr>
              {tableHeaders.map((headCell) => (
                <th
                  className="heading-3"
                  key={headCell.id}
                  style={{
                    width: headCell.minWidth,
                    minWidth: headCell.minWidth,
                    padding: "12px 6px",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="lg" level="body-sm">
                    {headCell.label}
                  </Typography>
                  {/* )} */}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isFetching || isLoadingSearch ? (
              <tr>
                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                  <CircularProgress />
                </td>
              </tr>
            ) : entries?.length === 0 ? (
              <tr>
                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                  <Typography>
                    No bills found
                    {isSearchActive ? " matching your filters." : "."}
                  </Typography>
                </td>
              </tr>
            ) : (
              entries.map((invoice: any, index: any) => (
                <tr key={invoice.id || invoice.bts_no}>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bts_no)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.vendor_name)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.vendor_code)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.consignee_user_id)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.consignee_name)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.consignee_mobile)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.consignee_address)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{formatDate(invoice.bts_entry_date)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.po_no || invoice.po_contract)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bill_no)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.gem_type)}</Typography>
                  </td>
                  {!isPendingPage && (
                    <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                      <Typography level="body-xs">{displayOptional(invoice?.invoicenumber)}</Typography>
                    </td>
                  )}
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{formatDate(invoice.bill_date)}</Typography>
                  </td>
                  <td style={{ textAlign: "end", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.tax_amount)}</Typography>
                  </td>
                  <td style={{ textAlign: "end", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bill_amount)}</Typography>
                  </td>
                  {/* <td style={{ textAlign: "center" }}>
                    <Chip
                      size="sm"
                      variant="soft"
                      color={
                        invoice.status?.toLowerCase().includes("pending")
                          ? "warning"
                          : invoice.status?.toLowerCase().includes("parked") || invoice.status?.toLowerCase().includes("submitted")
                          ? "primary"
                          : invoice.status?.toLowerCase().includes("approved") ||
                            invoice.status?.toLowerCase().includes("accepted") ||
                            invoice.status?.toLowerCase().includes("paid")
                          ? "success"
                          : invoice.status?.toLowerCase().includes("rejected") || invoice.status?.toLowerCase().includes("not parked")
                          ? "danger"
                          : "neutral"
                      }
                    >
                      {displayOptional(invoice.status)}
                    </Chip>
                  </td> */}
                  {/* <td style={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconButton size="sm" color="primary" variant="plain" onClick={() => handleView(invoice.bts_no)}>
                        <span title="View">
                          <VisibilityIcon />
                        </span>
                      </IconButton>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="plain"
                        onClick={() => handleEdit(invoice.bts_no, invoice.vendor_code)}
                        disabled={isPendingPage ? false : !invoice.status?.toLowerCase().includes("saved_as_draft")}
                      >
                        <span title="Approval">
                          <ApprovalIcon />
                        </span>
                      </IconButton>
                      {!isPendingPage && (
                        <IconButton
                          size="sm"
                          color="danger"
                          variant="plain"
                          disabled={!invoice.status?.toLowerCase().includes("saved_as_draft")}
                          onClick={() => setDeleteModalId(invoice.bts_no)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                  </td> */}
                  <td style={{ textAlign: "center" }}>
                    <Autocomplete
                      placeholder="Choose assign to"
                      options={gemInvoiceList}
                      sx={{ width: 200 }}
                      onChange={(event, newInputValue) => {
                        handlechooseGemInvoiceMember(newInputValue, index, invoice);
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Sheet>

      {/* Pagination is now safely rendered */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 0,
        }}
      >
        <Box></Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button size="sm" variant="outlined" onClick={handlePrevPage} disabled={!pagination || pagination?.page <= 1}>
            Previous
          </Button>
          <Typography level="body-sm" sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
            Page {pagination?.page} of {pagination?.pages}
          </Typography>
          <Button size="sm" variant="outlined" onClick={handleNextPage} disabled={!pagination || pagination?.page >= pagination?.pages}>
            Next
          </Button>
        </Box>

        <Button size="sm" className="btn btn-primary" disabled={selectedList.length === 0} onClick={onHendleSendSelectedList}>
          Forward
        </Button>
      </Box>
      <Modal
        open={!!deleteModalId}
        onClose={() => (!deleteInprogress ? setDeleteModalId(null) : null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            zIndex: 1300,
            bgcolor: "background.surface",
            border: "1px solid",
            borderColor: "neutral.outlinedBorder",
            boxShadow: "lg",
            borderRadius: "md",
            p: 3,
          }}
        >
          <Typography level="h4">Confirm Deletion</Typography>
          <Typography sx={{ mt: 1 }}>Are you sure you want to delete this bill? This action cannot be undone.</Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
              mt: 3,
            }}
          >
            <Button variant="outlined" color="neutral" onClick={() => setDeleteModalId(null)} disabled={deleteInprogress}>
              Cancel
            </Button>

            <Button
              variant="solid"
              color="danger"
              loading={deleteInprogress}
              onClick={() => {
                handleDelete(deleteModalId);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment >
  );
}


